(() => {
    const tabs = document.querySelectorAll('.js-tabs');
    if (tabs.length) {
        [...tabs].forEach((tabs) => {
            const tabButtons = tabs.querySelectorAll('[role="tab"]');
            const tabContents = tabs.querySelectorAll('[role="tabcontent"]');

            const handleTabClick = (event) => {
                if (tabContents) {
                    tabContents.forEach((content) => {
                        content.hidden = true;
                    });
                }

                if (tabButtons) {
                    tabButtons.forEach((tabButton) => {
                        tabButton.setAttribute('aria-selected', 'false');
                    });
                }

                event.currentTarget.setAttribute('aria-selected', 'true');
                const {id} = event.currentTarget;
                const tabContent = tabs.querySelector(`[aria-labelledby="${id}"]`);

                if (tabContent) {
                    tabContent.hidden = false;
                }
            };

            if (tabButtons) {
                tabButtons.forEach((button) =>
                    button.addEventListener('click', handleTabClick)
                );
            }
        });
    }
})();
